$(document).ready(function () {
    var mapEl = document.getElementById('map');

    if (mapEl != null) {
        let latLng = {lat: 1.9403, lng: 29.8739};
        //let latLng = new google.maps.LatLng(this.latitude, this.longitude);
        let mapOptions = {
            center: latLng,
            zoom: 3,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            styles: mapStyles(),
            keyboardShortcuts: false,
        };
        setTimeout(() => {
            const map = new google.maps.Map(document.getElementById('map'), mapOptions);
            const image = '/images/pin.png';
            //add some markers
            let marker = new google.maps.Marker({
                position: {lat: -2.372136, lng: 36.636776},
                map,
                //title: 'EXP56789',
                //description: 'Processing',
                icon: image,
            });

            let marker2 = new google.maps.Marker({
                position: {lat: -27.215348, lng: 30.088924},
                map,
                //title: 'EXP56789',
                //description: 'Processing',
                icon: image,
            });
        }, 800);
    }

    function mapStyles() {
        return [
            {
                'featureType': 'administrative',
                'elementType': 'labels.text.fill',
                'stylers': [
                    {
                        'color': '#444444',
                    },
                ],
            },
            {
                'featureType': 'landscape',
                'elementType': 'all',
                'stylers': [
                    {
                        'visibility': 'simplified',
                    },
                ],
            },
            {
                'featureType': 'landscape.natural.landcover',
                'elementType': 'geometry.fill',
                'stylers': [
                    {
                        'hue': '#00ff77',
                    },
                ],
            },
            {
                'featureType': 'landscape.natural.terrain',
                'elementType': 'geometry.fill',
                'stylers': [
                    {
                        'color': '#8bb09c',
                    },
                ],
            },
            {
                'featureType': 'poi',
                'elementType': 'all',
                'stylers': [
                    {
                        'visibility': 'off',
                    },
                ],
            },
            {
                'featureType': 'road',
                'elementType': 'all',
                'stylers': [
                    {
                        'saturation': -100,
                    },
                    {
                        'lightness': 45,
                    },
                ],
            },
            {
                'featureType': 'road.highway',
                'elementType': 'all',
                'stylers': [
                    {
                        'visibility': 'simplified',
                    },
                ],
            },
            {
                'featureType': 'road.arterial',
                'elementType': 'labels.icon',
                'stylers': [
                    {
                        'visibility': 'off',
                    },
                ],
            },
            {
                'featureType': 'transit',
                'elementType': 'all',
                'stylers': [
                    {
                        'visibility': 'off',
                    },
                ],
            },
            {
                'featureType': 'water',
                'elementType': 'all',
                'stylers': [
                    {
                        'color': '#93b9c6',
                    },
                    {
                        'visibility': 'on',
                    },
                    {
                        'lightness': '40',
                    },
                ],
            },
        ];
    }
});
